@if(importFileData) {
    <div class="col-12 flex align-items-center justify-content-start gap-2">
        <h3>Date : <span class="font-normal">{{ importFileData['date'] }}</span></h3>
        <p-button severity="success" label="Import Daily Summary" (onClick)="importSummaryData()" />
        <p-button severity="warning" label="Clear Previous Daily Summary Import" (onClick)="clearSummaryData()" />
    </div>

    <div class="col-12" *ngFor="let tableData of importFileData['tables']">

        <p-table [value]="tableData['data']" [columns]="tableData['headers']">
            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between">
                    {{ tableData['title'] }}
                </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let column of columns">{{ column }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-customer let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns">
                        {{ customer[col] }}
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <tr>
                    <td *ngFor="let col of tableData['headers']">
                        {{ tableData['summary'][col] }}
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td [attr.colspan]="columns.length" class="text-center font-bold">No Data Found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
}